import { render, staticRenderFns } from "./ManifestsTableAdmin.vue?vue&type=template&id=6f313d2b&scoped=true"
import script from "./ManifestsTableAdmin.vue?vue&type=script&lang=js"
export * from "./ManifestsTableAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f313d2b",
  null
  
)

export default component.exports